export const COMPANY_LIST = [
	{ value: '"', label: 'Select' },
	{ value: '9', label: 'AH Commissions' },
	{ value: '2', label: 'ALAM GROUP' },
	{ value: '7', label: 'AMBIT' },
	{ value: '3', label: 'ARISH GROUP' },
	{ value: '2', label: 'Fattah GROUP' },
	{ value: '1', label: 'FTL' },
	{ value: '1', label: 'FTL FAIZAN' },
	{ value: '2', label: 'Haider Autos' },
	{ value: '1', label: 'Imperial Solutions Limited' },
	{ value: '2', label: 'IMPERIAL SOLUTIONS LTD JAPAN' },
	{ value: '1', label: 'IMRAN BUTT ( EX SHINCHUO )' },
	{ value: '1', label: 'ISL INDIA' },
	{ value: '1', label: 'ISL JAMAICA' },
	{ value: '6', label: 'JapaneseCarTrade.com' },
	{ value: '2', label: 'Kade Group' },
	{ value: '1', label: 'M.A Solutions' },
	{ value: '1', label: 'NAUMAN ALI (NAG - NAUMAN ALI GROUP)' },
	{ value: '1', label: 'RST FATTAH' },
	{ value: '2', label: 'SALMAN S GROUP' },
	{ value: '3', label: 'Salman S Group ( SHAZAIB ALI )' },
	{ value: '1', label: 'SALMAN S GROUP ( SIMON STEVE)' },
	{ value: '1', label: 'SALMAN S TEAM ( SAAD )' },
	{ value: '2', label: 'Shakil Ahmad Farooqi ( RST FATTAH )' },
	{ value: '2', label: 'SK Group' },
	{ value: '2', label: 'SYBAX LAB' },
	{ value: '2', label: 'TRD GROUP' },
	{ value: '8', label: 'TRD WORLD' },
	{ value: '2', label: 'TS AUTO TRADE' },
	{ value: '4', label: 'Umar Farooq' },
	{ value: '5', label: 'ZAHID - SHONAN TRD' },
];